import React from "react";

const HomeBuyingGuidePage = () => {
  const sectionData = [
    {
      title: "Easy Guidelines For A Hassle-free Buying Experience via Housing.in",
      description:
        "Our real estate experts have collated valuable advice for you, which will help you get your dream home at its best cost! Below are a few factors that will make your home-buying process simple, ensuring that you choose a fantastic abode for your family!",
      items: [
        {
          text: "Set A Budget - Prepare an ideal budget and estimate your Home Loan Eligibility to plan your finances effectively.",
          image: "/expert.png",
        },
        {
          text: "Research The Location - Choose a location with accessibility to schools, healthcare, and good resale value.",
          image: "/sitevisits.png",
        },
        {
          text: "Choose The Right Type Of Property - Decide between ready-to-move or under-construction homes based on your needs.",
          image: "/construction.png",
        },
        {
          text: "Consider The Resale Value - Opt for properties with high price appreciation and desirable amenities.",
          image: "/deals.png",
        },
        {
          text: "Calculate Your Loan Eligibility - Check your eligibility and compare interest rates to find the best EMI plan.",
          image: "/shortlist.png",
        },
        {
          text: "Check Stamp Duty & Registration Fees - Understand these taxes as they vary from city to city.",
          image: "/legal.png",
        },
        {
          text: "Account For Additional Expenses - Plan for costs like GST, property taxes, and parking charges.",
          image: "/market.png",
        },
        {
          text: "Get Property Insurance - Secure your investment with insurance against natural disasters and theft.",
          image: "/searchProperties.png",
        },
        {
          text: "Choose Convenience Over Glamour - Focus on functionality over luxury to find a home that suits your needs.",
          image: "/expert.png",
        },
      ],
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl font-bold text-gray-800">
          Easy Home Buying Guidelines with <span className="text-blue-600">Housing.in</span>
        </h1>
        <p className="text-gray-600 mt-2">
          Your Trusted Partner for a Smooth Real Estate Journey
        </p>
      </header>

      {/* Sections */}
      {sectionData.map((section, index) => (
        <section key={index} className="my-8">
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            {section.description && (
              <p className="text-gray-600 mb-4">{section.description}</p>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {section.items.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center bg-gray-50 shadow-md rounded-lg p-4"
                >
                  <img
                    src={item.image}
                    alt={item.text}
                    className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
                  />
                  <p className="text-gray-700">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default HomeBuyingGuidePage;
